if (!customElements.get('testimonial-slider')) {
  customElements.define('testimonial-slider', class TestimonialSlider extends HTMLElement {
    index = 0

    constructor() {
      super()
      this.onTestimonialMouseEnter = this.onTestimonialMouseEnter.bind(this)
      this.onResize = this.onResize.bind(this)

      this.button = this.querySelector('button')
      this.slider = this.querySelector('ul')
      this.testimonials = this.querySelectorAll('li')

      this.testimonials.forEach((el, i) => {
        el.addEventListener('mouseenter', this.onTestimonialMouseEnter.bind(this, i))
      })
      this.button.addEventListener('click', this.onSlide.bind(this))
      window.addEventListener('resize', this.onResize)

      this.updateAriaHidden()
    }

    visibleCount() {
      return window.innerWidth >= 1024 ? 2 : 1
    }

    updateAriaHidden() {
      const count = this.visibleCount()
      const len = this.testimonials.length
      const visible = new Set(Array.from({ length: count }, (_, k) => (this.index + k) % len))
      this.testimonials.forEach((el, i) => {
        el.setAttribute('aria-hidden', visible.has(i) ? 'false' : 'true')
      })
    }

    onResize() {
      this.updateAriaHidden()
    }

    onTestimonialMouseEnter(index) {
      const previous = this.querySelector('.testimonial-card.previous')
      previous.classList.remove("previous")
      previous.style.backgroundColor = "transparent"

      const current = this.testimonials[index]
      current.classList.add("previous")
      current.style.backgroundColor = current.dataset.color
    }

    onSlide(event) {
      event.preventDefault()
      this.index = this.index + 1
      if (this.index == this.testimonials.length) this.index = 0
      this.slider.style.marginLeft = `-${this.index * this.testimonials[0].clientWidth}px`
      this.updateAriaHidden()
      this.onTestimonialMouseEnter(this.index)
    }
  })
}
